import {
  CANCEL_INIT_INCIDENT,
  CLOSE_DROPDOWN,
  INIT_INCIDENT_FLOW_FAILED,
  INIT_INCIDENT_FLOW_SUCCESS,
  RESET_FORMS,
  SELECT_TRIGGER_FORM,
  TOGGLE_FORM_SELECTION_DROPDOWN,
} from 'actions/incidentManagement/initIncident';
import { FETCH_BY_REQUEST_ID_RESET } from 'actions/flowFormSubmission';

const initialState = {
  isDropdownOpen: false,
  selectedTriggerFormId: null,
  requestId: null,
  mayHaveEvents: false,
  mayHaveIncident: false,
};

export default function initIncident(state = initialState, action) {
  switch (action.type) {
    case CLOSE_DROPDOWN:
      return {
        ...state,
        isDropdownOpen: false,
      };
    case TOGGLE_FORM_SELECTION_DROPDOWN:
      return {
        ...state,
        isDropdownOpen: !state.isDropdownOpen,
      };
    case SELECT_TRIGGER_FORM:
      return {
        ...state,
        isDropdownOpen: false,
        selectedTriggerFormId: action.payload.triggerFormId,
      };
    case CANCEL_INIT_INCIDENT:
    case INIT_INCIDENT_FLOW_FAILED:
    case FETCH_BY_REQUEST_ID_RESET:
    case RESET_FORMS:
      return {
        ...initialState,
        triggerForms: state.triggerForms,
      };

    case INIT_INCIDENT_FLOW_SUCCESS: {
      return {
        ...state,
        selectedTriggerFormId: null,
        ...action.payload,
      };
    }

    default:
      return state;
  }
}
